export default __webpack_public_path__ + "static/media/arkham knight.2e369021.jpg";